module.exports = __webpack_public_path__ + "26ba4682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/partnerships_kfc.png
// module id = 1701
// module chunks = 0